import { piiSharingDispatches } from 'pages/integrations/containers/LtiIntegrationContainer/piiSharing/constants';
import { ltiPiiSharingService } from 'services/integrations';
import { messageNotification } from 'helpers';

const fetchPiiSharingConfigs = () => {
  return (dispatch) => {
    dispatch(piiSharingDispatches.fetchPiiSharingConfigsRequest());
    ltiPiiSharingService
      .fetchPiiSharingConfigs()
      .then((response) => dispatch(piiSharingDispatches.fetchPiiSharingConfigsSuccess(response.data)))
      .catch((error) => {
        messageNotification('danger', 'Error', 'There was an error loading PII sharing configurations.');
        dispatch(piiSharingDispatches.fetchPiiSharingConfigsFailure(error));
      });
  };
};

const updatePiiSharingConfig = (courseId, enabled) => {
  const previousEnabled = !enabled;
  return (dispatch) => {
    dispatch(piiSharingDispatches.updatePiiSharingConfigSuccess(courseId, enabled));
    ltiPiiSharingService
      .updatePiiSharingConfig(courseId, enabled)
      .then(() => {
        messageNotification(
          'success',
          'Success',
          `PII sharing has been ${enabled ? 'enabled' : 'disabled'} for this course.`
        );
      })
      .catch((error) => {
        const errorMessage =
          error.response?.data?.error || error.response?.data?.message || 'There was an error updating PII sharing.';
        messageNotification('danger', 'Error', errorMessage);
        dispatch(piiSharingDispatches.updatePiiSharingConfigFailure(courseId, previousEnabled));
      });
  };
};

const addPiiSharingCourse = (courseKey) => {
  return async (dispatch) => {
    try {
      await ltiPiiSharingService.updatePiiSharingConfig(courseKey, true);
      messageNotification('success', 'Success', 'Course has been added to PII sharing.');
      dispatch(fetchPiiSharingConfigs());
    } catch (error) {
      const errorMessage =
        error.response?.data?.error || error.response?.data?.message || 'There was an error adding this course.';
      messageNotification('danger', 'Error', errorMessage);
      throw error;
    }
  };
};

export const piiSharingActions = {
  fetchPiiSharingConfigs,
  updatePiiSharingConfig,
  addPiiSharingCourse
};
